import RoundedButtonLinkPrimary from '../../../components/button/rounded-button-link-primary/RoundedButtonLinkPrimary';
import OrganizationCtaCard from './OrganizationCtaCard';

const OrganizationLinkCard = ({ title, description, banner, link, linkText }) => {
    return (
        <OrganizationCtaCard title={title} description={description} banner={banner}>
            <RoundedButtonLinkPrimary to={link}>{linkText}</RoundedButtonLinkPrimary>
        </OrganizationCtaCard>
    );
};

export default OrganizationLinkCard;
